import { useContext, useMemo } from 'react'
import GlobalContext from '../context/GlobalContext'
import { LegalStructure } from '../config/i18nConfig'
import { getI18NName } from '../components/Combobox/i18n/I18NCombobox'
import { useTranslation } from 'react-i18next'

type ReturnProps = {
    loaded: boolean
    legalStructures: LegalStructure[]
    getLegalStructure: (id: string) => LegalStructure
    getLegalStructureName: (id: string) => string
    getLegalStructureByName: (name: string) => LegalStructure
}

export default function useLegalStructures(): ReturnProps {
    const { i18n } = useTranslation()

    const { legalStructures } = useContext(GlobalContext)
    const loaded = useMemo<boolean>(() => legalStructures.length > 0, [legalStructures])

    const getLegalStructure = (id: string) => (legalStructures || []).find(value => value.alpha === id)
    const getLegalStructureName = (id: string) =>
        getI18NName(
            (legalStructures || []).find(value => value.alpha === id),
            i18n.language,
        )
    const getLegalStructureByName = (name: string) =>
        (legalStructures || []).find(value =>
            value.names.some(i18nName => i18nName.value.toLowerCase().localeCompare(name.toLowerCase()) === 0),
        )

    return { loaded, legalStructures, getLegalStructure, getLegalStructureName, getLegalStructureByName }
}
